import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceunderscore' })
export class ReplaceUnderscorePipe implements PipeTransform {
  public transform(value: any): any {
    return value.replace(/_/g, ' ');
  }
}
